import * as yup from 'yup'
import { IntlShape, defineMessages } from 'react-intl'

import { GTCampaign, GTCampaignType } from 'gql/types.generated'

const messages = defineMessages({
  required: {
    id: 'coupons.newTemplate.form.required',
    defaultMessage: 'Field required'
  },
  length: {
    id: 'coupons.newTemplate.form.length',
    defaultMessage: 'The prefix can be up to {max} characters'
  },
  timeRequired: {
    id: 'coupons.newTemplate.form.timeRequired',
    defaultMessage: 'Time required'
  },
  minValue: {
    id: 'coupons.newTemplate.form.minValue',
    defaultMessage: 'The minimum value is {min}'
  }
})

export const schema = (intl: IntlShape, canCreateDBSubcampaign?: boolean): yup.AnyObjectSchema => {
  return yup.object().shape({
    campaign: yup.object().shape({
      id: yup.string().required(intl.formatMessage(messages.required))
    }),
    prefix: yup.string().max(3, ({ max }) => intl.formatMessage(messages.length, { max })),
    value: yup
      .number()
      .min(1, ({ min }) => intl.formatMessage(messages.minValue, { min }))
      .required(intl.formatMessage(messages.required)),
    expirationTime: yup.object().shape({
      value: yup
        .number()
        .min(1, ({ min }) => intl.formatMessage(messages.minValue, { min }))
        .required(intl.formatMessage(messages.timeRequired))
    }),
    confirmationModalities: yup.array().min(1, intl.formatMessage(messages.required)),
    salesChannels: yup
      .array()
      .min(1, ({ min }) => intl.formatMessage(messages.minValue, { min }))
      .required(intl.formatMessage(messages.required)),
    file: yup.mixed().when('campaign', {
      is: (campaign: Partial<GTCampaign>) =>
        campaign?.type === GTCampaignType.UniqueCouponForDatabase && canCreateDBSubcampaign,
      then: yup.mixed().required(intl.formatMessage(messages.required))
    }),
    subcampaignName: yup.string().when('campaign', {
      is: (campaign: Partial<GTCampaign>) =>
        campaign?.type === GTCampaignType.UniqueCouponForDatabase && canCreateDBSubcampaign,
      then: yup.string().required(intl.formatMessage(messages.required))
    })
  })
}
